export enum PromotionType {
  QOW = 'Question of the week',
  BECOME_EXPERT = 'BecomeExpert',
  QUIZ = 'Quiz',
  POW = 'Puzzle of the week',
}
